import { Button } from '@/components/elements/forms/buttons';
import { LoginContextType } from '@/hooks/useLogin';
import { _s } from '@/locale';
import { TriggerSource } from '@/types/analytics';
import { Link } from 'react-router-dom';

type CreateAccountProps = Pick<LoginContextType, 'email' | 'handleEmailSubmit'> & {
  source: TriggerSource;
  redirectUrl: string;
};
const translationKey = 'CreateAccount';

const CreateAccount = ({ email, source, redirectUrl, handleEmailSubmit }: CreateAccountProps) => {
  const handleLoginClick = () => {
    handleEmailSubmit({ triggerSource: source, redirectUrl });
  };

  return (
    <>
      <p className="text-fg_secondary pb-sm text-m">
        {_s(`${translationKey}.noAccount`)}
        <span className="text-fg_link">{email.value}</span>
      </p>
      <Button onClick={handleLoginClick} size="md">
        {_s(`${translationKey}.cta`)}
      </Button>
      <div className="flex flex-col items-center justify-center">
        <p className="text-fg_secondary text-m">
          {_s(`${translationKey}.terms.text`)}{' '}
          <Link to="/articles/terms-booking-consumer" target="_blank" className="text-nowrap underline">
            {_s(`${translationKey}.terms.link`)}
          </Link>
        </p>
      </div>
    </>
  );
};

export default CreateAccount;
